import { render, staticRenderFns } from "./EmularityGameCard.vue?vue&type=template&id=788f3c86&"
import script from "./EmularityGameCard.vue?vue&type=script&lang=js&"
export * from "./EmularityGameCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports